import { resolveKnowledgeParticleQaDisplay } from '../components/KnowledgeParticleQaSections';

export type AiChatSourceParticle = {
  particleId: string;
  title?: string;
  questionText: string;
  answerText?: string;
};

type ParticleLike = {
  particleId?: string | null;
  particleTitle?: string | null;
  particleQuestions?: unknown;
  particleAnswers?: unknown;
};

function qaPartsToText(parts: { main: string; items: string[] }): string {
  const chunks: string[] = [];
  const main = String(parts.main || '').trim();
  if (main) chunks.push(main);
  parts.items.forEach((item, index) => {
    const text = String(item || '').trim();
    if (text) chunks.push(`(${index + 1}) ${text}`);
  });
  return chunks.join('\n').trim();
}

/** 从会话颗粒构造对话用的来源题目上下文（题干 + 可选参考解答） */
export function buildAiChatSourceParticles(
  particles: ParticleLike[] | null | undefined,
  particleIds: Array<string | null | undefined>,
): AiChatSourceParticle[] {
  const wanted = [...new Set(
    particleIds.map((id) => String(id || '').trim()).filter(Boolean),
  )];
  if (!wanted.length || !particles?.length) return [];

  const byId = new Map(
    particles
      .map((entry) => [String(entry.particleId || '').trim(), entry] as const)
      .filter(([id]) => Boolean(id)),
  );

  return wanted.flatMap((particleId) => {
    const entry = byId.get(particleId);
    if (!entry) return [];
    const display = resolveKnowledgeParticleQaDisplay({
      questionSource: entry.particleQuestions,
      answerSource: entry.particleAnswers,
      fallbackQuestionText: entry.particleTitle || undefined,
    });
    const questionText = qaPartsToText(display.questionDisplay);
    const answerText = qaPartsToText(display.answerDisplay);
    if (!questionText && !answerText) return [];
    return [{
      particleId,
      title: entry.particleTitle || undefined,
      questionText: questionText || entry.particleTitle || particleId,
      ...(answerText ? { answerText } : {}),
    }];
  });
}
